module.exports = __webpack_public_path__ + "static/media/edit_list_ic.a9277b46.svg";